import { TTS_SERVICE } from './urls'

export function getRandomizeMessage<T>(array: T[]) {
  return array[Math.floor(Math.random() * array.length)]
}

export function sleep(timeout: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, timeout))
}

export const isTotallyScrolledReversed = (target: HTMLElement) => {
  // eslint-disable-next-line max-len
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
  // reversed because of flex-direction: column-reverse (iOS)
  return target.scrollHeight <= target.clientHeight - target.scrollTop
}

export const isOverlayTotallyScrolled = (target: HTMLElement) => {
  // eslint-disable-next-line max-len
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
  return target.scrollHeight - target.scrollTop <= target.clientHeight
}

export const isSmallDevice = () => {
  return document.body.clientWidth <= 768
}

export const blockEvent = (e: Event) => {
  e.preventDefault()
  e.stopPropagation()
}
class Queue<T> {
  elements: Record<number, T> = {}
  head = 0
  tail = 0

  enqueue(element: T) {
    this.elements[this.tail] = element
    this.tail++
  }
  dequeue() {
    const item = this.elements[this.head]
    delete this.elements[this.head]
    this.head++
    return item
  }
  peek() {
    return this.elements[this.head]
  }
  get length() {
    return this.tail - this.head
  }
  get isEmpty() {
    return this.length === 0
  }
}

const audioPlayerCtx = () => {
  const urlsQueue = new Queue<string>()
  let audio: HTMLAudioElement | undefined

  const playAudio = () => {
    if (urlsQueue.length && audio == undefined) {
      audio = new Audio(urlsQueue.dequeue())
      audio.oncanplay = () => {
        audio?.play()
        audio = undefined
        playAudio()
      }
    }
  }

  return {
    readMessage: ({
      message,
      locale
    }: {
      message?: string
      locale?: string
    }) => {
      if (locale == 'en_US' || locale == 'sv_SE') {
        const lang = locale.split('_')[0]
        const url = `${TTS_SERVICE}/${lang}/?text=${message}`
        urlsQueue.enqueue(url)
        playAudio()
      }
    }
  }
}
export const { readMessage } = audioPlayerCtx()
